// This file is generated, do not edit!
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */

import { type ApiError, type Scheduler } from "../../api";
import { useGetScheduler as useGetter } from "../hooks";
import { type QueryKey, useQuery, type UseQueryOptions } from "react-query";

export function useSchedulerQueryKey(schedulerId: string): QueryKey {
  return ["api", "v1", "schedulers", schedulerId];
}

export function useScheduler(
  schedulerId: string,
  options: Omit<
    UseQueryOptions<Scheduler, ApiError>,
    "queryKey" | "queryFn"
  > = {}
): Scheduler {
  const getter = useGetter();
  return useQuery(
    useSchedulerQueryKey(schedulerId),
    () => getter(schedulerId),
    options
  ).data!;
}
